import { webLightTheme, webDarkTheme } from "@fluentui/tokens";
export const fabricSemanticTokensLight = {
    iconErrorColor: webLightTheme.colorStatusDangerForeground1,
    iconValidationColor: webLightTheme.colorStatusSuccessForeground1,
    iconSystemColor: webLightTheme.colorPaletteBlueForeground2,
    iconContentManagementColor: webLightTheme.colorPaletteGrapeBorderActive,
    iconMonitoringColor: webLightTheme.colorPaletteMarigoldForeground2,
    iconMiscColor: webLightTheme.colorNeutralForeground2,
    colorRibbonIconError: webLightTheme.colorStatusDangerForeground1,
    colorRibbonIconErrorDisabled: webLightTheme.colorPaletteCranberryBackground2,
    colorRibbonIconValidation: webLightTheme.colorStatusSuccessForeground1,
    colorRibbonIconValidationDisabled: webLightTheme.colorPaletteGreenBackground2,
    colorRibbonIconSysconfig: webLightTheme.colorPaletteBlueForeground2,
    colorRibbonIconSysconfigDisabled: webLightTheme.colorPaletteBlueBackground2,
    colorRibbonIconContentMgt: webLightTheme.colorPaletteGrapeBorderActive,
    colorRibbonIconContentMgtDisabled: webLightTheme.colorPaletteGrapeBackground2,
    colorRibbonIconMonitoring: webLightTheme.colorPaletteMarigoldForeground2,
    colorRibbonIconMonitoringDisabled: webLightTheme.colorPaletteGoldBackground2,
    colorRibbonIconMisc: webLightTheme.colorNeutralForeground2,
    colorRibbonIconMiscDisabled: webLightTheme.colorNeutralForegroundDisabled
};
export const fabricSemanticTokensDark = {
    iconErrorColor: webDarkTheme.colorStatusDangerBackground3,
    iconValidationColor: webDarkTheme.colorPaletteLightGreenBorder1,
    iconSystemColor: webLightTheme.colorPaletteBlueBorderActive,
    iconContentManagementColor: webLightTheme.colorPaletteLilacBorderActive,
    iconMonitoringColor: webLightTheme.colorPaletteGoldBorderActive,
    iconMiscColor: webDarkTheme.colorNeutralForeground1,
    colorRibbonIconError: webDarkTheme.colorStatusDangerBackground3,
    colorRibbonIconErrorDisabled: webDarkTheme.colorPaletteCranberryBackground2,
    colorRibbonIconValidation: webDarkTheme.colorPaletteLightGreenBackground3,
    colorRibbonIconValidationDisabled: webDarkTheme.colorPaletteGreenBackground2,
    colorRibbonIconSysconfig: webLightTheme.colorPaletteBlueBorderActive,
    colorRibbonIconSysconfigDisabled: webDarkTheme.colorPaletteBlueBackground2,
    colorRibbonIconContentMgt: webLightTheme.colorPaletteLilacBorderActive,
    colorRibbonIconContentMgtDisabled: webDarkTheme.colorPaletteLilacBackground2,
    colorRibbonIconMonitoring: webLightTheme.colorPaletteGoldBorderActive,
    colorRibbonIconMonitoringDisabled: webDarkTheme.colorPaletteGoldBackground2,
    colorRibbonIconMisc: webDarkTheme.colorNeutralForeground1,
    colorRibbonIconMiscDisabled: webDarkTheme.colorNeutralForegroundDisabled
};
